<form [formGroup]="form" *ngIf="form.controls">
    <div class="row m-0">
        <div class="col-12 p-3" *ngIf="fb && fb.error">
            <lib-error [title]="getErrorMsgText()" [error]="fb.error"></lib-error>
        </div>
    </div>

    <div class="row m-0">
        <div class="col-12 pt-3">
            <div class="col-12 px-0">
                <lib-select-box [labelBlock]="true" [idName]="'tagType'" [label]="'Tag Type:'" [source]="tagTypes" 
                    [control]="form.controls.tagType"></lib-select-box>
            </div>
            <div class="col-12 px-0">
                <lib-text-box [labelBlock]="true" [idName]="'tagTitleEn'" [label]="'English:'" [control]="form.controls.tagTitleEn" 
                    [maxLength]="255" [shortLengthCount]="true"></lib-text-box>
            </div>
            <div class="col-12 px-0">
                <lib-text-box [labelBlock]="true" [idName]="'tagTitleUs'" [label]="'English(US):'" [control]="form.controls.tagTitleUs" 
                    [maxLength]="255" [shortLengthCount]="true"></lib-text-box>
            </div>
            <div class="col-12 px-0">
                <lib-text-box [labelBlock]="true" [idName]="'tagTitleFr'" [label]="'French:'" [control]="form.controls.tagTitleFr" 
                    [maxLength]="255" [shortLengthCount]="true"></lib-text-box>
            </div>
            <div class="col-12 px-0">
                <lib-text-box [labelBlock]="true" [idName]="'tagTitleNl'" [label]="'Dutch:'" [control]="form.controls.tagTitleNl" 
                    [maxLength]="255" [shortLengthCount]="true"></lib-text-box>
            </div>
            <div class="col-12 px-0">
                <lib-text-box [labelBlock]="true" [idName]="'tagTitleDe'" [label]="'German:'" [control]="form.controls.tagTitleDe" 
                    [maxLength]="255" [shortLengthCount]="true"></lib-text-box>
            </div>
        </div>
    </div>
    <div class="row m-0 mb-2">
        <div class="col-12">
            <p class="mb-4 text-muted">
                If you don't enter translations, English will be used as default.
            </p>
        </div>
    </div>
    <div class="row m-0">
        <div class="col-12">
            <div class="button-container">
                <button class="btn btn-danger mb-3" (click)="close()">Cancel</button>
                <button class="btn btn-success ml-4 mb-3" [disabled]="!form.valid || !form.dirty" (click)="save()">Save Changes</button>
            </div>
        </div>
    </div>
</form>

<div class="col-12 loading-screen" *ngIf="isBusy">
    <lib-loading
        [status]="'text-primary'" 
        [spinnerPosition]="true"
        [text]="spinnerText"
        [size]="'md'">
    </lib-loading>
</div>